import { IEProvinceCode } from '../../models/province-code/ie-province-code.enum';

export const IEProvinceName = new Map<IEProvinceCode, string>([
  [IEProvinceCode.Carlow, 'Carlow'],
  [IEProvinceCode.Cavan, 'Cavan'],
  [IEProvinceCode.Clare, 'Clare'],
  [IEProvinceCode.Cork, 'Cork'],
  [IEProvinceCode.Donegal, 'Donegal'],
  [IEProvinceCode.Dublin, 'Dublin'],
  [IEProvinceCode.Galway, 'Galway'],
  [IEProvinceCode.Kerry, 'Kerry'],
  [IEProvinceCode.Kildare, 'Kildare'],
  [IEProvinceCode.Kilkenny, 'Kilkenny'],
  [IEProvinceCode.Laois, 'Laois'],
  [IEProvinceCode.Leitrim, 'Leitrim'],
  [IEProvinceCode.Limerick, 'Limerick'],
  [IEProvinceCode.Longford, 'Longford'],
  [IEProvinceCode.Louth, 'Louth'],
  [IEProvinceCode.Mayo, 'Mayo'],
  [IEProvinceCode.Meath, 'Meath'],
  [IEProvinceCode.Monaghan, 'Monaghan'],
  [IEProvinceCode.Offaly, 'Offaly'],
  [IEProvinceCode.Roscommon, 'Roscommon'],
  [IEProvinceCode.Sligo, 'Sligo'],
  [IEProvinceCode.Tipperary, 'Tipperary'],
  [IEProvinceCode.Waterford, 'Waterford'],
  [IEProvinceCode.Westmeath, 'Westmeath'],
  [IEProvinceCode.Wexford, 'Wexford'],
  [IEProvinceCode.Wicklow, 'Wicklow'],
]);
